export interface CountryInfo {
  countryCode: string;
  countryName: string;
  countryNameUkr?: string;
  countryNameRu?: string;
  imgSrc: string;
}

export interface CountryLimit {
  name: string;
  maxDimensions: string;
  maxWeight: number;
  maxCost: number | string | null;
}

export interface PriorityCountriesInfo {
  [key: string]: CountryLimit;
}

export const PriorityCountries: PriorityCountriesInfo = {
  UA: {
    name: 'Ukraine',
    maxDimensions: '70x42x40',
    maxWeight: 30,
    maxCost: null,
  },
  US: {
    name: 'United States of America',
    maxDimensions: '120x60x60',
    maxWeight: 30,
    maxCost: '800$',
  },
  CA: {
    name: 'Canada',
    maxDimensions: '120x60x60',
    maxWeight: 30,
    maxCost: '150 CAD',
  },
};
